import { GoogleLogin, GoogleOAuthProvider, CredentialResponse } from '@react-oauth/google';

const GOOGLE_CLIENT_ID: string = (window as any).__CONFIG__?.googleClientId || process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

interface GoogleLoginButtonProps {
  onSignIn(googleUser: CredentialResponse): void;
  onError(): void;
}

function GoogleLoginButton({ onSignIn, onError }: GoogleLoginButtonProps) {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleLogin onSuccess={onSignIn} onError={onError} auto_select />
    </GoogleOAuthProvider>
  );
}

export default GoogleLoginButton;
